import { Component, AfterViewInit, OnInit, OnDestroy, NgZone, ViewChild, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';

import {
  TdLoadingService,
  TdMediaService,
  ITdDataTableColumn,
  TdDataTableSortingOrder,
  TdDataTableService,
  ITdDataTableSortChangeEvent,
  TdDataTableComponent,
} from '@covalent/core';

import { PlanActuacion } from '../../../../models';

import { PlanActuacionService, LoginService } from '../../../../services/';

@Component({
  selector: 'qs-planactuacion',
  templateUrl: './planactuacion.component.html',
  styleUrls: ['./planactuacion.component.scss'],
  viewProviders: [PlanActuacionService],
})
export class PlanActuacionComponent implements AfterViewInit, OnInit, OnDestroy {

   private idPaciente: string;
  private planActuacion: PlanActuacion[];

  private _xsScreen: Subscription;

  // ITDdDataTableComponent
  // Columnas
  private columnsAll: ITdDataTableColumn[] = [
    { name: 'fecha', label: 'Fecha', tooltip: 'Fecha', sortable: true },
    { name: 'hora', label: 'Hora', tooltip: 'Hora', sortable: false },
    { name: 'texto', label: 'PlanActuacion', tooltip: 'PlanActuacion', sortable: false },
    { name: 'linea', label: 'Linea', sortable: false, hidden: true },
    { name: 'visita', label: 'Visita', sortable: false, hidden: true },
    { name: 'cias', label: 'Cias', sortable: false, hidden: true },
    { name: 'tipo', label: 'Tipo', sortable: false, hidden: true },
    { name: 'numeroExpediente', label: 'Núm. Exp.', sortable: false, hidden: true },
    { name: 'dniMedico', label: 'DNI', sortable: false, hidden: true },
    { name: 'idPlanActuacion', label: 'Id PlanActuacion', hidden: true },
    { name: 'accion', label: 'Acción', sortable: false, hidden: true },
  ];

  private columns: ITdDataTableColumn[] = this.columnsAll;
  // Datos
  private filteredData: PlanActuacion[] = [];
  private filteredDataTotal: number;

  // Propiedades
  private clickable: boolean = true;
  private selectable: boolean = false;
  private sortable: boolean = true;
  private sortBy: string = 'fecha';
  private sortOrder: TdDataTableSortingOrder = TdDataTableSortingOrder.Descending;
  private searchTerm: string = '';

  @ViewChild(TdDataTableComponent) tableComponent: TdDataTableComponent;

  constructor(private _titleService: Title,
    private _loadingService: TdLoadingService,
    public media: TdMediaService,
    private _planActuacionService: PlanActuacionService,
    private _loginService: LoginService,
    private _dataTableService: TdDataTableService,
    private _ngZone: NgZone,
    private _router: Router,
    private _route: ActivatedRoute,
    private _changeDetectorRef: ChangeDetectorRef) { }

  ngAfterViewInit(): void {
    this.media.broadcast();
    this.watchScreen();
    this._loadingService.register('planactuacion.load');
    this._planActuacionService.obtenerPlanActuacion(this._loginService.consulta.numeroExpediente, this._loginService.consulta.visita)
    .subscribe((res: any) => {
      this.planActuacion = res.respuesta.plan || '';
      this.filteredData = this.planActuacion;
      this.filteredDataTotal = this.planActuacion.length;
      this._loadingService.resolve('planactuacion.load');
    }, (error: Error) => {
      this._loadingService.resolve('planactuacion.load');
    });
    this._changeDetectorRef.detectChanges();
  }

  ngOnInit(): void {
    this.watchScreen();
  }

  /**
   * watchScreen:
   * Observable de cambio de resolució. Oculta o muestra columnas
   * xs < 600px
   * sm > 600px
   * md < 1280px
   */
  watchScreen(): void {
    this._xsScreen = this.media.registerQuery('xs').subscribe((matches: boolean) => {
      this._ngZone.run(() => {
        if (matches) {
          // Ocultamos columnas
          this.columns[0].hidden = true;
          // this.tableComponent.refresh();
        } else {
          // Mostramos columnas
          this.columns[0].hidden = false;
          // this.tableComponent.refresh();
        }
      });
    });
  }

  openDetalleAlta(): void {
    this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/hojadeseguimiento',
    { outlets: { hojadeseguimiento: ['plandetalle'] } }]);
  }

  /**
   * openDetalle: Muestra la vista de detalle pasando la linea seccionado
   * @param any: $event <- Fila seleccionada
   */
  openDetalle(planActuacion: PlanActuacion): void {
    if (planActuacion) {
      this._loginService.transient = planActuacion;
      this._router.navigate(['/main/consulta/' + this._loginService.consulta.numeroExpediente + '/hojadeseguimiento',
      { outlets: { hojadeseguimiento: ['plandetalle'] } }]);
    }
  }

  sort(sortEvent: ITdDataTableSortChangeEvent): void {
    this.sortBy = sortEvent.name;
    this.sortOrder = sortEvent.order;
    this.filter();
  }

  search(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.filter();
  }

  filter(): void {
    let newData: any[] = this.planActuacion;
    newData = this._dataTableService.filterData(newData, this.searchTerm, true);
    this.filteredDataTotal = newData.length;
    newData = this._dataTableService.sortData(newData, this.sortBy, this.sortOrder);
    this.filteredData = newData;
  }

  ngOnDestroy(): void {
    this._xsScreen.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/consulta/hojadeseguimiento/planactuacion/planactuacion.component.ts